/* @flow */
import * as React from 'react';

import type { FieldProps } from 'redux-form';

import InputDatePicker from 'components/InputDatePicker';

import protones from 'utils/protones';

const FormDatePicker = (props: FieldProps): React$Element<any> => {
  const { input, meta, ...rest } = props;
  const selected = protones.dateMillisToMoment(input.value);
  return <InputDatePicker {...input} {...rest} selected={selected} />;
};

export default FormDatePicker;
